/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Reset_SubmitInputs */

const cs_auth_reset_submit = /** @type {(inputs: Auth_Reset_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložit heslo`)
};

const en_auth_reset_submit = /** @type {(inputs: Auth_Reset_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save password`)
};

/**
* | output |
* | --- |
* | "Save password" |
*
* @param {Auth_Reset_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_reset_submit = /** @type {((inputs?: Auth_Reset_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Reset_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_reset_submit(inputs)
	return cs_auth_reset_submit(inputs)
});